import { computed } from 'vue'
import { FEATURE_FLAGS } from '@gat-ship/feature-flag'
import { useFormatting } from '@gat-ship/utils'
import { formatBuildString } from '../model/startup-state-logic'

/**
 * Build-info shell: reads the build date from the environment and the dev flag,
 * then delegates the display-string decision to the pure core. The component
 * reaches `formatBuildString` only through this composable (the MVVM seam).
 */
export function useBuildInfo() {
  const { formatDateTime } = useFormatting()

  const currentBuild = computed(() =>
    formatBuildString(
      import.meta.env['VITE_BUILD_DATE'],
      FEATURE_FLAGS.IS_DEV,
      formatDateTime
    )
  )

  return { currentBuild }
}
